import { Component, OnInit, OnDestroy, TemplateRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ConstantValues } from 'src/app/bpg-common/models/bpg-constants';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { SelfService } from '../../bpg-self-services/self-services.service.ts';
import { Router } from '@angular/router';
import { BpgCommonService } from '../../bpg-common/services/bpg-common.service';
import { UploadService } from 'src/app/bpg-self-services/d-i/upload.service';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { BpgAdminServices } from 'src/app/bpg-admin/bpg-admin-services';
import { NgSelectComponent } from '@ng-select/ng-select';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

interface NotificationDraft {
  readonly subject: string;
  readonly body: string;
  readonly bpgId: any;
  readonly siteIds: ReadonlyArray<any>;
  readonly emails: ReadonlyArray<string>;
  readonly files: ReadonlyArray<File>;
}

interface NotificationReview extends NotificationDraft {
  readonly userId: any;
  readonly audience: string;
  readonly audienceParts: ReadonlyArray<{ text: string; placeholder: boolean }>;
  readonly manualEmails: ReadonlyArray<string>;
}

@Component({
  selector: 'app-push-notification',
  templateUrl: './push-notification.component.html',
  styleUrls: ['./push-notification.component.css']
})
export class PushNotificationComponent implements OnInit, OnDestroy {
  @ViewChild('callAPIDialog', { static: false }) callAPIDialog: TemplateRef<any>;
  @ViewChild('userSelect', { static: false }) userSelect: NgSelectComponent;
  @ViewChild('reviewDialog', { static: false }) reviewDialog: TemplateRef<any>;
  review: NotificationReview = null;
  private reviewDialogRef: MatDialogRef<any>;
  private recipientRequestId = 0;
  private siteRequestId = 0;
  manualEmails: string[] = [];
  attachmentWarnings: string[] = [];
  recipientsLoadError = false;
  sendStatus = '';
  adminId: any = localStorage.getItem('adminId');
  loginDetails: any;
  loginData: any;
  loginUserId: any;
  timeoutErrorMessage: string = ConstantValues.timeoutErrorMessage;
  timeOutError = false;
  selectedChapter: any;
  chapterNotification = '';
  chapterList: any = []
  method: string;
  param: string;
  msg1: string;
  notificationSuccess = false;
  notificationFailure = false;
  errorMsg: any;
  fileSizeConstant = "Upload document(< 500MB)"
  fileName = this.fileSizeConstant;
  fileExtensionError = false;
  fileSizeExtensionError = false;
  fileSize = 0;
  fileUploadSuccess: boolean;
  chapterNotificationSuccess: boolean;
  awsUrls: any;
  fileList: any = [];
  removeToolbarHeaders: any = { disableNativeSpellChecker: false, autoParagraph: false, toolbar: 'Basic', extraPlugins: 'colorbutton', uiColor: '#FFFFFF', basicEntities: false, fillEmptyBlocks: false, removeButtons: 'Source,Save,NewPage,Preview,Print,Templates,Pasteas plain text,PastefromWord,Find,Replace,SelectAll,Form,Checkbox,Radio,TextField,Textarea,SelectionField,Button,ImageButton,HiddenField,Decrease,Increase,Block,Create Div Container,Text direction from left to right,Text direction from right to left,Set language,Image,Flash,Table,Horizontal,Smiley,Insert Special Character,Insert Page Break for Printing,IFrame,Formatting,Paragraph,Font,FontSize,Maximize,ShowBlocks,About,forceSpellChecker,Cut,Copy,Paste,Undo,Redo,Strike,Subscript,Superscript,RemoveFormat', height: '300px', maxLength: '4000', Backgroundcolor: 'black !important' };
  siteList: any;
  bpgList: any;
  userAndRoleIdDTO: any;

  selectedBpgsData: any;
  selectedSiteIds: any = [];
  bpgId: any;
  allSiteIds: any;
  siteId: any;
  subject: string
  emailList: any = [];
  memberUserId: any = [];
  selectedEmail: any = [];
  copySuccess = false;
  copyFailure = false;
  recipientsLoading = false;
  peopleSearchLoading = false;
  isSending = false;
  searchTerm: any;
  search: boolean;
  userList: any[] = [];
  noUser: boolean;
  userFound: boolean;
  customSearchFn = () => true;
  selectedUserList: any = [];
  selectedEmailString = '';
  userFirstName: string;
  userExists: boolean;
  usersAdded: boolean;
  filterList: any;
  showCustomDateRange = false;
  startDate: any;
  endDate: any;
  selectedFilter: any;
  todaysDate: any = new Date();
  maxDate: any = new Date();
  showJoinedDateField = false
  countOfSignedUser = 10
  limit: number = ConstantValues.pageLimit;
  noMemberFound = false;
  startDateGreaterError = false;
  isbpgAdmin = false;
  isbpgLeadAdmin = false;
  selectAllConstant = 'Select All';
  recipientType = 'MEMBERS';
  allSitesSelected = false;
  constructor(
    private readonly  spinner: Ng4LoadingSpinnerService,
    private readonly  router: Router,
    private readonly selfService: SelfService,
    private readonly bpgCommonService: BpgCommonService,
    private readonly dialog: MatDialog,
    private readonly uploadService: UploadService,
    private readonly bpgAdminServices: BpgAdminServices,
    private readonly cdr: ChangeDetectorRef) { }

  ngOnInit() {
    const savedLoginData = localStorage.getItem('loginData');
    try {
      this.loginData = savedLoginData ? JSON.parse(savedLoginData) : null;
    } catch (_error) {
      this.loginData = null;
    }
    if (!this.loginData || this.loginData.userId === undefined || this.loginData.userId === null) {
      this.router.navigate(['/log-out']);
      return;
    }
    this.loginDetails = this.loginData;
    this.loginUserId = this.loginData.userId;

    if(localStorage.getItem('isbpgAdmin') === 'true')
    {
      this.isbpgAdmin = true
}
     if(localStorage.getItem('isbpgLeadAdmin') === 'true')   
     {
        this.isbpgLeadAdmin = true
     }
    if (this.adminId !== "1" && this.adminId !== "2" && this.adminId !== "3" && !this.isbpgAdmin && !this.isbpgLeadAdmin) {
      this.router.navigate(['/site-home']);
    }

    this.userAndRoleIdDTO = {
      userId: this.loginData['userId'],
      roleId: localStorage.getItem('adminId')
    }
    this.bpgCommonService.getSessionToken();
    this.logUserAction();
    if (this.chapterNotification != null && this.chapterNotification !== undefined && this.chapterNotification !== '') {
      this.chapterNotificationSuccess = true

    }
    if (this.chapterNotification === null || this.chapterNotification === undefined || this.chapterNotification === '') {
      this.chapterNotificationSuccess = false
    }
    this.filterList =
      [{ filterId: 1, filterName: 'All' },
      { filterId: 2, filterName: 'Custom Date Range' },
      { filterId: 3, filterName: 'Last 7 days' },
      { filterId: 4, filterName: 'Last 30 days' },
      { filterId: 5, filterName: 'Last 6 Months' },
      { filterId: 6, filterName: 'Last 12 Months' }];
    this.getAllErgs()
  }

  ngOnDestroy() {
    this.recipientRequestId++;
    this.siteRequestId++;
    if (this.reviewDialogRef) {
      this.reviewDialogRef.close();
    }
  }

  getAllErgs() {
    const landingDto = {
      "filter": {},
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "",
      "uid": ""
    };
    this.spinner.show();
    this.selfService.getAllBpg(landingDto).subscribe(data => {
      this.bpgList = data;
      this.bpgList.unshift({ bpgId: 0, bpgName: this.selectAllConstant });
      this.spinner.hide();
    }, () => {
      this.spinner.hide();
    })
  }


  /** For fetching site list
  * @class PushNotificationComponent
  * @method siteChange
  */
  public bpgChange(event) {
    const requestId = ++this.siteRequestId;
    this.clearAudienceRecipients();
    this.selectedEmail = [];
    this.selectedFilter = 1;
    this.startDate = null;
    this.endDate = null;
    this.noMemberFound = false;
    this.copySuccess = false
    this.copyFailure = false;
    this.usersAdded = false;
    this.selectedSiteIds = [];
    this.memberUserId = [];
    this.emailList = [];
    this.siteId = null;
    this.siteList = [];
    this.recipientType = 'MEMBERS';
    this.allSitesSelected = false;
    this.bpgId = event ? event.bpgId : null;

    if (this.bpgId === null || this.bpgId === undefined) {
      return;
    }

    if (Number(this.bpgId) === 0) {
      const selectAllSite = { siteId: 0, siteName: this.selectAllConstant };
      this.siteList = [selectAllSite];
      this.siteId = [selectAllSite];
      this.selectedSiteIds = [0];
      this.allSitesSelected = true;
      this.getChapterMembersEmails();
      return;
    }

    this.selectedBpgsData =
    {
      "filter": {
        "bpgId": this.bpgId,
        "userId": this.userAndRoleIdDTO.userId,
        "adminId": this.userAndRoleIdDTO.roleId
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "string",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }
    this.siteList = []
    this.spinner.show();
    this.bpgCommonService.getMySiteList(this.selectedBpgsData).subscribe(data => {
      if (requestId !== this.siteRequestId) { return; }
      this.siteList = data;
      this.siteList.unshift({ siteId: 0, siteName: this.selectAllConstant });
      this.spinner.hide();
    }, () => {
      if (requestId !== this.siteRequestId) { return; }
      this.spinner.hide();
    });
  }
  siteChange(e) {
    this.clearAudienceRecipients();
    this.noMemberFound = false;
    this.copySuccess = false;
    this.copyFailure = false;
    this.usersAdded = false;
    const selectedSites = e || [];
    this.allSitesSelected = selectedSites.some(site => Number(site.siteId) === 0);

    if (Number(this.bpgId) === 0) {
      const selectAllSite = selectedSites.find(site => Number(site.siteId) === 0);
      this.siteId = selectAllSite ? [selectAllSite] : [];
      this.selectedSiteIds = selectAllSite ? [0] : [];

      if (selectAllSite) {
        this.getChapterMembersEmails();
      } else {
        this.selectedEmail = [];
        this.emailList = [];
      }
      return;
    }

    this.siteId = selectedSites;
    for (const i of selectedSites) {
      if (i.siteId === 0 && i.siteName === this.selectAllConstant) {
        this.siteId = this.siteList.filter(site => site.siteName !== this.selectAllConstant);
        break
      }
    }
    if (this.siteId != null && this.bpgId != null && this.siteList.length > 0) {
      this.selectedSiteIds = [];
      if (this.siteId.length > 0) {
        for (const site of this.siteId) {
          this.selectedSiteIds.push(site.siteId);
        }
      }

      this.getChapterMembersEmails();
    }
  }
  getChapterMembersEmails() {
    this.clearAudienceRecipients();
    const requestId = this.recipientRequestId;
    this.noMemberFound = false;
    this.startDateGreaterError = false;
    this.recipientsLoading = false;

    if (this.allSitesSelected && this.recipientType === 'MEMBERS') {
      this.recipientType = 'ERG_ADMIN';
      this.resetJoinedDateFilter();
    }

    if (this.selectedFilter === 2 && (!this.startDate || !this.endDate)) {
      this.showCustomDateRange = true;
      this.emailList = [];
      this.selectedEmail = [];
      return;
    }
    else if (this.selectedFilter === 2 && this.startDate != null && this.endDate != null && this.endDate < this.startDate) {
      this.startDateGreaterError = true;
    }
    else {
      if (this.selectedSiteIds.length === 0) { return; }
      this.recipientsLoading = true;
      this.emailList = [];
      this.selectedEmail = [];
      this.spinner.show();
      if (this.showJoinedDateField) {
        if (this.selectedFilter !== 2 || (this.selectedFilter === 2 && this.startDate != null && this.endDate != null)) {
          if (this.selectedFilter !== 2) {
            this.startDate = null;
            this.endDate = null;
            this.showCustomDateRange = false
          }

        }

      }
      if (this.showJoinedDateField === false) {
        this.selectedFilter = 0;
        this.startDate = null;
        this.endDate = null;
      }

      this.allSiteIds = this.selectedSiteIds.toString();

      if (this.recipientType !== 'MEMBERS') {
        this.filterEmailsByAdminRole();
        return;
      }
   
      this.selectedBpgsData =
      {
        "filter": {
          "bpgId": this.bpgId,
          "userId": 0,
          "siteId": Number(this.bpgId) === 0 ? '0' : this.allSiteIds,
          "filterId": this.selectedFilter,
          'startDate': this.startDate,
          'endDate': this.endDate
        },
        "moduleId": 0,
        "page": 0,
        "presentRole": "string",
        "searchTerm": "string",
        "size": 0,
        "sortDirection": "ASC",
        "sortProperty": "string",
        "uid": "string"
      }




      this.bpgCommonService.getChapterEmailList(this.selectedBpgsData).subscribe(data => {
        if (requestId !== this.recipientRequestId) { return; }
        const emails = new Set<string>();
        this.emailList = (data || []).filter(email => {
          const key = (email.emailId || '').trim().toLowerCase();
          if (!key || emails.has(key)) { return false; }
          emails.add(key);
          return true;
        }).map(email => ({ ...email, emailId: email.emailId.trim() }));
        this.selectedEmail = this.emailList.map(email => email.emailId);
        this.noMemberFound = this.emailList.length === 0;
        this.recipientsLoading = false;
        this.spinner.hide();
      }, () => {
        if (requestId !== this.recipientRequestId) { return; }
        this.recipientsLoadError = true;
        this.recipientsLoading = false;
        this.spinner.hide();
      });
    }
  }

  /** loads emailList/selectedEmail for ERG Admins or ERG Lead Admins
  * from the chapter admin roster
  * @class PushNotificationComponent
  * @method filterEmailsByAdminRole
  */
  filterEmailsByAdminRole() {
    const requestId = this.recipientRequestId;
    this.recipientsLoading = true;
    if (this.selectedSiteIds.length === 0) {
      this.selectedEmail = [];
      this.noMemberFound = true;
      this.recipientsLoading = false;
      this.spinner.hide();
      return;
    }

    const selectedBpg = (this.bpgList || []).find(bpg => String(bpg.bpgId) === String(this.bpgId));
    const selectedSiteNames = new Set((this.siteList || [])
      .filter(site => this.selectedSiteIds.some(siteId => String(siteId) === String(site.siteId)))
      .map(site => site.siteName));
    const adminFilterDto = {
      "filter": {
        "createdBy": this.loginUserId,
        "adminId": this.userAndRoleIdDTO.roleId,
        "bpgId": this.bpgId,
        "siteId": '0'
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": 1000,
      "sortDirection": "ASC",
      "sortProperty": "user_first_name",
      "uid": ""
    };
    const wantedRoleId = this.recipientType === 'ERG_LEAD_ADMIN' ? 2 : 3;
    const isGlobalSelection = Number(this.bpgId) === 0 &&
      this.selectedSiteIds.length === 1 && Number(this.selectedSiteIds[0]) === 0;

    this.getAllChapterAdminPages(adminFilterDto).subscribe(admins => {
      if (requestId !== this.recipientRequestId) { return; }
      const emails = new Set<string>();
      const scopedAdmins = admins.filter(admin =>
        Number(admin.adminId) === wantedRoleId &&
        (isGlobalSelection || (selectedBpg && admin.bpgName === selectedBpg.bpgName && selectedSiteNames.has(admin.siteName))));

      this.emailList = scopedAdmins.filter(admin => {
        const key = (admin.emailId || '').trim().toLowerCase();
        if (!key || emails.has(key)) {
          return false;
        }
        emails.add(key);
        return true;
      }).map(admin => ({
        userId: admin.userId,
        emailId: admin.emailId.trim()
      }));
      this.selectedEmail = this.emailList.map(admin => admin.emailId);
      this.noMemberFound = this.emailList.length === 0;
      this.recipientsLoading = false;
      this.spinner.hide();
    }, () => {
      if (requestId !== this.recipientRequestId) { return; }
      this.recipientsLoadError = true;
      this.recipientsLoading = false;
      this.spinner.hide();
    });
  }

  private getAllChapterAdminPages(adminFilterDto: any, page = 0, accumulated: any[] = []): Observable<any[]> {
    const request = { ...adminFilterDto, page };
    return this.bpgAdminServices.getAllChapterAdmins(request).pipe(
      switchMap(data => {
        const admins = accumulated.concat(data && data.content ? data.content : []);
        const pageSize = Number(request.size) || 1;
        const totalPages = data && data.totalPages !== undefined
          ? Number(data.totalPages)
          : Math.ceil(Number(data && data.totalElements !== undefined ? data.totalElements : admins.length) / pageSize);

        return page + 1 < totalPages
          ? this.getAllChapterAdminPages(adminFilterDto, page + 1, admins)
          : of(admins);
      })
    );
  }

  private clearAudienceRecipients() {
    this.recipientRequestId++;
    this.selectedEmail = [];
    this.emailList = [];
    this.manualEmails = [];
    this.recipientsLoading = false;
    this.recipientsLoadError = false;
    this.spinner.hide();
  }

  onRecipientTypeChange() {
    if (this.recipientType !== 'MEMBERS') {
      this.resetJoinedDateFilter();
    }
    this.getChapterMembersEmails();
  }

  get noRecipientFoundMessage(): string {
    if (this.recipientType === 'ERG_ADMIN') {
      return 'No ERG admins found.';
    }
    if (this.recipientType === 'ERG_LEAD_ADMIN') {
      return 'No ERG lead admins found.';
    }
    return 'No chapter members found.';
  }

  private buildAudienceSummaryParts(): { text: string; placeholder: boolean }[] {
    const erg = (this.bpgList || []).find(bpg => String(bpg.bpgId) === String(this.bpgId));
    const ergSelected = Number(this.bpgId) === 0 && this.bpgId != null ? 'All ERGs' : (erg ? erg.bpgName : null);
    const sites = this.allSitesSelected ? 'All Sites' : (this.siteId || []).map(site => site.siteName).join(', ');
    const role = this.recipientType === 'ERG_ADMIN' ? 'ERG Admins'
      : this.recipientType === 'ERG_LEAD_ADMIN' ? 'ERG Lead Admins' : 'Members';
    const parts: { text: string; placeholder: boolean }[] = [ergSelected
      ? { text: ergSelected, placeholder: false }
      : { text: 'Choose an ERG', placeholder: true }];
    if (sites) {
      parts.push({ text: sites, placeholder: false });
    }
    parts.push({ text: role, placeholder: false });
    if (this.showJoinedDateField && this.recipientType === 'MEMBERS') {
      const filter = (this.filterList || []).find(item => item.filterId === this.selectedFilter);
      if (this.selectedFilter === 2 && this.startDate && this.endDate) {
        parts.push({ text: `Joined ${this.startDate.toLocaleDateString()} to ${this.endDate.toLocaleDateString()}`, placeholder: false });
      } else if (filter) {
        parts.push({ text: `Joined: ${filter.filterName}`, placeholder: false });
      } else {
        parts.push({ text: 'Choose a joined-date filter', placeholder: true });
      }
    }
    return parts;
  }

  get audienceSummary(): string {
    return this.buildAudienceSummaryParts().map(part => part.text).join(' › ');
  }

  get selectedManualCount(): number {
    return this.selectedEmail.filter(email => this.isManualEmail(email)).length;
  }

  isManualEmail(email: string): boolean {
    return this.manualEmails.indexOf(email.trim().toLowerCase()) !== -1;
  }

  private visibleMessage(body: string): string {
    const document = new DOMParser().parseFromString(body || '', 'text/html');
    document.querySelectorAll('script, style').forEach(element => element.remove());
    return (document.body.textContent || '').replace(/[\u200B-\u200D\uFEFF]/g, '').trim();
  }

  private validateNotification(draft: NotificationDraft): string[] {
    const blockers: string[] = [];
    if (draft.bpgId === null || draft.bpgId === undefined) { blockers.push('select an ERG'); }
    if (!draft.siteIds.length) { blockers.push('select at least one site'); }
    if (!draft.subject || !draft.subject.trim()) { blockers.push('add a subject'); }
    else if (draft.subject.length > 500) { blockers.push('shorten the subject (max 500 characters)'); }
    if (!this.visibleMessage(draft.body)) { blockers.push('write a message'); }
    if (draft.body && draft.body.length > 4000) { blockers.push('shorten the message (max 4000 characters including formatting)'); }
    if (!draft.emails.length) { blockers.push('select at least one recipient'); }
    if (draft.files.reduce((size, file) => size + file.size, 0) > 524288000) {
      blockers.push('remove attachments to stay within the 500 MB total limit');
    }
    return blockers;
  }

  /** Shared by the review button and its handler; send validates the reviewed snapshot. */
  get sendBlockers(): string[] {
    const blockers = this.validateNotification({
      subject: this.subject, body: this.chapterNotification, bpgId: this.bpgId,
      siteIds: this.selectedSiteIds, emails: this.selectedEmail, files: this.fileList
    });
    if (this.recipientsLoading) { blockers.push('wait for recipients to finish loading'); }
    if (this.recipientsLoadError) { blockers.push('retry loading recipients'); }
    if (this.showJoinedDateField && this.recipientType === 'MEMBERS') {
      if (this.selectedFilter === null || this.selectedFilter === undefined) {
        blockers.push('choose a joined-date filter option');
      } else if (this.selectedFilter === 2) {
        if (!this.startDate || !this.endDate) {
          blockers.push('choose a start and end date');
        } else if (isNaN(new Date(this.startDate).getTime()) || isNaN(new Date(this.endDate).getTime())) {
          blockers.push('choose valid dates');
        } else if (this.startDate > this.endDate) {
          blockers.push('fix the date range (start date must be on or before end date)');
        } else if (this.startDate > new Date() || this.endDate > new Date()) {
          blockers.push('choose dates on or before today');
        }
      }
    }
    return blockers;
  }

  sendEmail() {
    this.selectedEmailString = this.selectedEmail.join(',');
    window.location.assign("mailto:" + this.selectedEmailString);
  }
  async copyText() {
    this.copySuccess = false;
    this.copyFailure = false;
    this.selectedEmailString = this.selectedEmail.join(';');
    try {
      if (!navigator.clipboard || !navigator.clipboard.writeText) {
        throw new Error('Clipboard API unavailable');
      }
      await navigator.clipboard.writeText(this.selectedEmailString);
      this.copySuccess = true;
      setTimeout(() => this.copySuccess = false, 3000);
    } catch (_error) {
      this.copyFailure = true;
    }
  }

  showJoinedDateFilter() {
    const nextShowJoinedDateField = !this.showJoinedDateField;
    this.resetJoinedDateFilter();
    if (nextShowJoinedDateField) {
      this.showJoinedDateField = true;
      this.selectedFilter = 1;
    }
    if (this.selectedSiteIds.length > 0) {
      this.getChapterMembersEmails();
    }
  }

  /** the joined-date filter only applies to Members; other recipient types ignore it entirely */
  resetJoinedDateFilter() {
    this.startDateGreaterError = false;
    this.showJoinedDateField = false;
    this.selectedFilter = 0;
    this.startDate = null;
    this.endDate = null;
    this.showCustomDateRange = false;
  }

  removeText() {
    this.selectedEmail = [];
    this.emailList = [];
    this.manualEmails = [];
    this.copySuccess = false;
    this.copyFailure = false;
    this.usersAdded = false;
  }

  openAndCloseMatDialog(type) {
    if (type === 'open') {
      this.usersAdded = false;
      this.userExists = false;
      this.noUser = false;

      const dialogConfig = new MatDialogConfig();
      dialogConfig.width = '760px';
      dialogConfig.maxWidth = 'calc(100vw - 32px)';
      dialogConfig.maxHeight = 'calc(100vh - 32px)';
      dialogConfig.autoFocus = false;
      dialogConfig.ariaLabelledBy = 'add-people-dialog-title';
      dialogConfig.panelClass = 'pn-dialog-panel';
      dialogConfig.backdropClass = 'pn-dialog-backdrop';
      const dialogRef = this.dialog.open(this.callAPIDialog, dialogConfig);
      dialogRef.afterOpened().subscribe(() => {
        if (this.userSelect) {
          this.userSelect.focus();
        }
      });
      dialogRef.afterClosed().subscribe(() => this.resetAddPeopleDialogState());
    }

    else {
      this.dialog.closeAll();
    }

  }

  private resetAddPeopleDialogState() {
    this.userFound = false;
    this.noUser = false;
    this.searchTerm = null;
    this.userList = [];
    this.selectedUserList = [];
    this.userExists = false;
    this.userFirstName = '';
    this.search = false;
    this.peopleSearchLoading = false;
  }
  searchBy() {

    this.userExists = false

    this.search = true;
    this.searchTerm = (this.searchTerm) ? this.searchTerm : '';
    this.getUserList();
  }
  /** to list users other than admins
* @class AdminComponent
* @method getUserList
*/

  getUserList() {
    this.timeOutError = false;
    this.peopleSearchLoading = true;
    this.spinner.show();
    this.selectedBpgsData =
    {
      "filter": {
        "leadershipPosition": "USER"
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": this.searchTerm,
      "size": 10,
      "sortDirection": "ASC",
      "sortProperty": "um.user_first_name",
      "uid": "string"
    }

    this.selfService.getUserDropDown(this.selectedBpgsData).subscribe(data => {
      this.userList = data;
      this.cdr.detectChanges();
      if (this.userList.length === 0) {
        this.noUser = true;
        this.userFound = false;

      } else {
        if (this.search) {
          this.userFound = true;
          this.noUser = false;
        }
        this.userList.forEach((i) => { i.userFirstName = `${i.userFirstName} ${i.userLastName}`; });
      }

      this.peopleSearchLoading = false;
      this.spinner.hide();


    }, err => {
      this.peopleSearchLoading = false;
      this.spinner.hide();
      if (err && err.value && err.value.statusText === ConstantValues.unknownError) {
        this.timeOutError = true;
      }
    });
  }
  userSelection($event) {
    if (!$event || !$event.emailId) { return; }
    this.userExists = false;
    this.userFound = false;
    this.searchTerm = '';
    const email = $event.emailId.trim().toLowerCase();
    const alreadySelected = this.selectedEmail.some(value => value.trim().toLowerCase() === email)
      || this.selectedUserList.some(user => user.emailId.trim().toLowerCase() === email);

    if (!alreadySelected) {

      // val not found, pushing onto array

      this.selectedUserList.push($event);
      this.userFirstName = '';
      this.userList = [];
      this.search = false;
      // ng-select retains internal selected-item state independent of ngModel; clear it explicitly
      setTimeout(() => this.userSelect && this.userSelect.clearModel(), 0);

    } else {

      this.userExists = true
      this.userFound = false

    }

  }


  removeUser(emailId) {
    this.selectedUserList = this.selectedUserList.filter(user => user.emailId !== emailId);
    this.search = false;
  }


  resetSelectedUser() {

    this.selectedUserList = [];
    this.userFound = false;
    this.searchTerm = null;
    this.userList = null;
    this.userFirstName = '';
    this.search = false;
    this.userExists = false;
    this.peopleSearchLoading = false;
  }
  addUserToList() {
    this.userExists = false
    this.method = "addUsersToEmailList";
    this.param = '';
    this.msg1 = 'Are you sure you want to add the selected user(s) to the recipient list?'

  }
  addUsersToEmailList() {
    if (this.recipientsLoading || this.recipientsLoadError || this.isSending) { return; }
    for (const user of this.selectedUserList) {
      const email = (user.emailId || '').trim();
      const key = email.toLowerCase();
      if (!email || this.selectedEmail.some(value => value.trim().toLowerCase() === key)) { continue; }
      const existing = this.emailList.find(item => item.emailId.trim().toLowerCase() === key);
      if (!existing) {
        this.emailList = [...this.emailList, { userId: user.userId, emailId: email }];
        if (this.manualEmails.indexOf(key) === -1) { this.manualEmails.push(key); }
      }
      this.selectedEmail = [...this.selectedEmail, existing ? existing.emailId : email];
    }
    this.openAndCloseMatDialog('close');
    this.usersAdded = true;
    this.noMemberFound = false;
    setTimeout(() => this.usersAdded = false, 3000);

  }
  


  deleteFile(d) {
    const index = this.fileList.indexOf(d);
    if (index !== -1) {
      this.fileList.splice(index, 1);
    }
    this.updateFileState();
  }
  findbyEmail(e){
    const text = e.target.value;
    if(text.length>2){
     this.searchTerm = text;
     this.searchBy();
    } else {
      this.userList = [];
      this.noUser = false;
      this.userFound = false;
      this.peopleSearchLoading = false;
    }
  }
  /** For capturing files detail
* @class PushNotificationComponent
* @method onFileSelected
*/
  public onFileSelected(event) {
    const allowedExtensions = ["jpg", "jpeg", "png", "pdf", "ppt", "pptx", "txt", "doc", "docx", "xlsx", "csv"];
    const maxTotalSize = 524288000;
    const selectedFiles = Array.prototype.slice.call(event.target.files || []) as File[];

    this.attachmentWarnings = [];
    let runningTotal = this.fileList.reduce((size, file) => size + file.size, 0);
    const acceptedFiles = [];

    for (const file of selectedFiles) {
      const extension = file.name.split('.').pop().toLowerCase();
      if (allowedExtensions.indexOf(extension) === -1) {
        this.attachmentWarnings.push(`${file.name}: unsupported file type; not added.`);
        continue;
      }
      if (runningTotal + file.size > maxTotalSize) {
        this.attachmentWarnings.push(`${file.name}: exceeds the 500 MB total limit; not added.`);
        continue;
      }
      if (this.fileList.concat(acceptedFiles).some(existing => existing.name === file.name)) {
        this.attachmentWarnings.push(`${file.name}: a file with this name is already selected; not added.`);
        continue;
      }
      runningTotal += file.size;
      acceptedFiles.push(file);
    }

    this.fileList = this.fileList.concat(acceptedFiles);
    this.updateFileState();
    event.target.value = '';
  }

  private updateFileState() {
    this.fileSize = this.fileList.reduce((size, file) => size + file.size, 0);
    this.fileName = this.fileList.length ? this.fileList.map(file => file.name).join(' , ') : this.fileSizeConstant;
    this.fileSizeExtensionError = this.fileSize > 524288000;
    this.fileExtensionError = false;
  }


  /**To reset notification
 * @class PushNotificationComponent
 * @method resetClick
 */
  resetClick() {
    this.method = "resetClickConfirmation";
    this.param = '';
    this.msg1 = "Your current changes will be discarded. Do you want to continue?";
  }

  /**To reset notification on confirmation
* @class PushNotificationComponent
* @method resetClickConfirmation
*/
  resetClickConfirmation() {
    this.siteRequestId++;
    this.clearAudienceRecipients();
    this.review = null;
    this.attachmentWarnings = [];
    this.sendStatus = '';
    this.startDateGreaterError = false;
    this.noMemberFound = false;
    this.copySuccess = false;
    this.copyFailure = false;
    this.usersAdded = false;
    this.showJoinedDateField = false;
    this.showCustomDateRange = false;
    this.selectedFilter = null;
    this.startDate = null;
    this.endDate = null;
    this.bpgId = null;
    this.chapterNotification = '';
    this.subject = '';
    this.fileName = this.fileSizeConstant;
    this.fileList = [];
    this.fileSize = 0;
    this.fileExtensionError = false;
    this.fileSizeExtensionError = false;
    this.notificationSuccess = false;
    this.notificationFailure = false;
    this.recipientsLoading = false;
    this.peopleSearchLoading = false;
    this.isSending = false;
    this.selectedSiteIds = [];
    this.siteId = null;
    this.siteList = [];
    this.errorMsg = '';
    this.selectedEmail = [];
    this.emailList = [];
    this.recipientType = 'MEMBERS';
    this.allSitesSelected = false;
    this.spinner.hide()
  }

  /**To send Notification
* @class PushNotificationComponent
* @method sendNotification
*/
  sendNotification() {
    if (this.isSending || this.reviewDialogRef || this.sendBlockers.length > 0) { return; }
    this.notificationFailure = false;
    this.notificationSuccess = false;
    this.errorMsg = '';
    this.sendStatus = '';
    this.review = Object.freeze({
      userId: this.loginDetails.userId,
      subject: this.subject,
      body: this.chapterNotification,
      bpgId: String(this.bpgId),
      siteIds: Object.freeze([...this.selectedSiteIds]),
      emails: Object.freeze([...this.selectedEmail]),
      files: Object.freeze([...this.fileList]),
      audience: this.audienceSummary,
      audienceParts: this.buildAudienceSummaryParts(),
      manualEmails: Object.freeze(this.selectedEmail.filter(email => this.isManualEmail(email)))
    });
    const config = new MatDialogConfig();
    config.width = '960px';
    config.maxWidth = 'calc(100vw - 32px)';
    config.maxHeight = 'calc(100vh - 32px)';
    config.autoFocus = true;
    config.ariaLabelledBy = 'notification-review-title';
    config.panelClass = 'pn-dialog-panel';
    config.backdropClass = 'pn-dialog-backdrop';
    this.reviewDialogRef = this.dialog.open(this.reviewDialog, config);
    this.reviewDialogRef.afterClosed().subscribe(() => {
      this.review = null;
      this.reviewDialogRef = null;
    });
  }

  closeReview() {
    if (!this.isSending && this.reviewDialogRef) { this.reviewDialogRef.close(); }
  }
  /**To send Notification on confirmation
* @class PushNotificationComponent
* @method onsendNotification
*/
  onsendNotification() {
    const reviewed = this.review;
    if (this.isSending || this.notificationFailure || !reviewed || this.validateNotification(reviewed).length > 0) {
      return;
    }
    this.isSending = true;
    this.reviewDialogRef.disableClose = true;
    this.sendStatus = 'Submitting notification…';
    this.spinner.show();
    this.copySuccess = false;
    this.copyFailure = false;

    const notificationData = {
      "userId": reviewed.userId,
      "notificationDesc": reviewed.body,
      "siteId": reviewed.siteIds,
      "bpgId": reviewed.bpgId,
      "fileNameList": reviewed.files.map(file => file.name),
      "subject": reviewed.subject,
      "serviceFunction": 'saveData',
      "emailIdTo": reviewed.emails.join(',')
    }
    this.selfService.sendChapterNotification(notificationData).subscribe(async data => {
      try {
        if (!data || data.message || data.body == null) {
          throw new Error((data && data.message) || 'Failed to send the notification');
        }
        const notificationId = data.body.notificationId;
        if (reviewed.files.length) {
          if (notificationId == null || !Number.isInteger(Number(notificationId)) || Number(notificationId) <= 0) {
            throw new Error('The server did not return a valid notification ID. Attachments were not uploaded.');
          }
          localStorage.removeItem('uploadError');
          this.awsUrls = await this.bpgCommonService.getAwsUrl({ category: 'uploadDocument' }).toPromise();
          for (const file of reviewed.files) {
            this.sendStatus = `Uploading ${file.name}…`;
            await this.uploadService.getPresignedUrl(file, this.awsUrls, Number(notificationId), 'chapter_notification');
            if (localStorage.getItem('uploadError') === 'Error') {
              localStorage.removeItem('uploadError');
              throw new Error('Failed to send the notification');
            }
          }
          this.sendStatus = 'Finalizing notification…';
          const fileResponse = await this.selfService.sendChapterNotification({
            "notificationId": notificationId,
            "serviceFunction": "savefile",
            "emailIdTo": reviewed.emails.join(','),
            "siteId": reviewed.siteIds,
            "bpgId": reviewed.bpgId,
          }).toPromise();
          if (!fileResponse || fileResponse.message || fileResponse.body == null) {
            throw new Error((fileResponse && fileResponse.message) || 'Failed to send the notification');
          }
        }
        this.isSending = false;
        this.closeReview();
        this.resetClickConfirmation();
        this.notificationSuccess = true;
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      } catch (error) {
        this.errorMsg = error.message || 'Failed to send the notification';
        this.notificationSuccess = false;
        this.notificationFailure = true;
      } finally {
        this.isSending = false;
        this.sendStatus = '';
        if (this.reviewDialogRef) { this.reviewDialogRef.disableClose = false; }
        this.spinner.hide();
      }
    }, error => {
      this.errorMsg = error.message || 'Failed to send the notification';
      this.notificationSuccess = false;
      this.notificationFailure = true;
      this.isSending = false;
      this.sendStatus = '';
      if (this.reviewDialogRef) { this.reviewDialogRef.disableClose = false; }
      this.spinner.hide();
    });
  }

  logUserAction() {
    const data = {
      userId : this.loginUserId,
      categoryDescription : "Push Notification"
    };
    this.bpgCommonService.logUserAction(data).subscribe(
      (_data) => {});
  }

  navigateToPushNotificationLogs(){
    this.router.navigate(['/push-notification-logs']);
  }

}
